import MeetingRoomReservation from './MeetingRoomReservation';
import Route from './route';

export default {
  RenderProp: MeetingRoomReservation,
  mainRoute: Route,
};
